(function( App, $, undefined ) {
    //Private Property
    //var isHot = true;

    //Public Property
    //utils.ingredient = "Bacon Strips";

    App.utils = App.utils || {};

    App.utils.str = App.utils.str || {};

    App.utils.number = App.utils.number || {};

    //Public Method
    App.utils.str.nl2br = function nl2br(str, is_xhtml) {
        //  discuss at: http://phpjs.org/functions/nl2br/
        // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // improved by: Philip Peterson
        // improved by: Onno Marsman
        // improved by: Atli Þór
        // improved by: Brett Zamir (http://brett-zamir.me)
        // improved by: Maximusya
        // bugfixed by: Onno Marsman
        // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        //    input by: Brett Zamir (http://brett-zamir.me)
        //   example 1: nl2br('Kevin\nvan\nZonneveld');
        //   returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
        //   example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
        //   returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
        //   example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
        //   returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'

        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display

        return (str + '')
        .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    App.utils.str.isASCII = function isASCII(str) {
        return /^[\x00-\x7F]*$/.test(str);
    }

    App.utils.number.format = function format(n, c, d, t) {
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;

       return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }

    App.utils.number.isNumeric = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    App.utils.number.parseInt = function format(str) {
        if(App.utils.number.isNumeric(str)) {
            return str;
        } else {
            str = str.replace(/\,/g,''); // 1125, but a string, so convert it to number

            return parseInt(str,10);
        }
    }

    App.utils.number.parseFloat = function format(str) {
        str = str.replace(/\,/g,''); // 1125, but a string, so convert it to number

        return parseFloat(str,10);
    }

    App.utils.number.roundDecimal = function format(num) {
        return Math.round(num * 100) / 100;
    }

    //Private Method
    function addItem( item ) {
        if ( item !== undefined ) {
            console.log( "Adding " + $.trim(item) );
        }
    }
}( window.App = window.App || {}, jQuery ));
